import { createContext, useContext, useState } from 'react';
import { prefersReducedMotion } from '../lib/motionPrefs';

// Site-wide animation kill switch (Chase 2026-07-19): the header button next
// to the cart toggles every background/effect animation, and the choice is
// cached in localStorage so it sticks across visits. OS reduced-motion still
// wins — motion is only ever ON when the user hasn't opted out either way.
const MotionContext = createContext(null);

const STORAGE_KEY = 'shinyvault-motion';

function getInitialPref() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'off' ? 'off' : 'on';
}

export function MotionProvider({ children }) {
  const [pref, setPref] = useState(getInitialPref);

  const toggleMotion = () => {
    setPref((p) => {
      const next = p === 'on' ? 'off' : 'on';
      localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  };

  const motionOn = pref === 'on' && !prefersReducedMotion();

  return (
    <MotionContext.Provider value={{ motionOn, motionPref: pref, toggleMotion }}>
      {children}
    </MotionContext.Provider>
  );
}

export function useMotion() {
  return useContext(MotionContext);
}
